export default defineNuxtRouteMiddleware(() => {
  const settings = useSettings()

  if (settings.value && settings.value.mainApiMaintenanceMode)
    return showError({ statusCode: 503, message: 'Maintenance', fatal: true })
})
